@if (isCityOnly()) {
  <odq-label-value style="width: 100%; height: 100%">
    <odq-label>{{ cityLabel }}</odq-label>
  </odq-label-value>
  @if (address.city) {
    <span>{{address.city}} {{address.provinceCode ? address.provinceCode : ''}} {{showPostalCode ? buildDisplayablePostalCode(address) : ''}}</span>
  }
} @else {
  <odq-label-value style="width: 100%; height: 100%">
    <odq-label>{{ addressLabel }}</odq-label>
  </odq-label-value>
  @if (!!address) {
    <div class="d-flex flex-column">
      @if (address.line1) {
        <span>{{address.line1}}</span>
      }
      @if (address.line2) {
        <span>{{address.line2}}</span>
      }
      @if (address.city) {
        <span>{{address.city}} {{address.provinceCode ? address.provinceCode : ''}} {{showPostalCode ? buildDisplayablePostalCode(address) : ''}}</span>
      }
      @if (address.countryCode) {
        <span>{{address.countryCode ? address.countryCode : ''}}</span>
      }
    </div>
  }
}


